import { createSlice, isPending, isRejected, isFulfilled } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import {
  deletePropertyFiles,
  getLegalDocuments,
  getPropertyDocuments,
  getPropertyFiles,
  getSelfDeclaration,
  updatePropertyDocumentStatus,
  uploadPropertyFiles,
} from './actionCreators';
import { initialState, DocumentsState, DOCUMENTS_SLICE_NAME } from './models';

export const slice = createSlice({
  name: DOCUMENTS_SLICE_NAME,
  initialState,
  reducers: {
    resetDocumentsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLegalDocuments.fulfilled, (state: DocumentsState, action) => {
        state.isLoading = false;
        state.legalDocuments = action.payload;
      })
      .addCase(getSelfDeclaration.fulfilled, (state: DocumentsState, action) => {
        state.isLoading = false;
        state.selfDeclaration = action.payload;
      })
      .addMatcher(
        isFulfilled(getPropertyFiles, uploadPropertyFiles, deletePropertyFiles),
        (state: DocumentsState, action) => {
          state.isLoading = false;
          state.files = action.payload;
        },
      )
      .addMatcher(
        isFulfilled(getPropertyFiles, uploadPropertyFiles, deletePropertyFiles),
        (state: DocumentsState, action) => {
          state.isLoading = false;
          state.files = action.payload;
        },
      )
      .addMatcher(isFulfilled(getPropertyDocuments, updatePropertyDocumentStatus), (state: DocumentsState, action) => {
        state.isLoading = false;
        state.propertyDocuments = action.payload;
      })
      .addMatcher(isPending(uploadPropertyFiles), (state: DocumentsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        isRejected(uploadPropertyFiles, getPropertyFiles, getPropertyDocuments, updatePropertyDocumentStatus),
        (state: DocumentsState, action) => {
          const error = action?.error;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetDocumentsState } = slice.actions;
export default slice.reducer;
